import { styled } from "@mui/material/styles";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

const PREFIX = "ZoomInMap";

const classes = {
	root: `${PREFIX}root`,
};

const StyledSvgIcon = styled(SvgIcon)(({
	theme,
}) => ({
	[`&.${classes.root}`]: {
		"& > *": {
			fill: "var(--PageHeaderToolbarIconColor)",
		},
	},
}));

interface ZoomInMapProps extends SvgIconProps {
}

export const ZoomInMap: FunctionComponent<ZoomInMapProps> = (props) => {
	return (
		<StyledSvgIcon
			className={classes.root}
			viewBox="0 0 16 16"
			{...props}
		>
			<path
				clipRule="evenodd"
				d="M4.975 0.7L3.325 2.35L1.225 0.25L0.25 1.225L2.275 3.4L0.625 5.05H4.975V0.7ZM13.75 5.05L12.1 3.4L14.2 1.225L13.225 0.25L11.05 2.35L9.4 0.7V5.05H13.75ZM9.4 13.825L11.05 12.175L13.225 14.2L14.2 13.225L12.1 11.125L13.75 9.475H9.4V13.825ZM0.625 9.475L2.275 11.125L0.25 13.225L1.225 14.2L3.325 12.175L4.975 13.825V9.475H0.625Z"
				fill="white"
				fillRule="evenodd"
			/>
		</StyledSvgIcon>
	);
};

export default ZoomInMap;

